import { useState } from 'react';
import { useAuth } from '../useAuth';
import { createShoppingList } from '../../lib/firebase/firestore';
import { useSound } from '../useSound';

interface ShoppingListFormData {
  name: string;
  budget: number;
  dishCount: number;
}

export const useShoppingListForm = (onSuccess?: () => void) => {
  const { user } = useAuth();
  const { playSound } = useSound();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: ShoppingListFormData) => {
    if (!user) {
      setError('Must be logged in to create lists');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const result = await createShoppingList({
        ...data,
        products: [],
        userId: user.uid,
        createdAt: new Date()
      });

      if (!result.success) {
        throw new Error('Failed to create list');
      }

      playSound('success');
      onSuccess?.();
    } catch (err) {
      setError('Error creating list. Please try again.');
      console.error('Error creating list:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    error,
    handleSubmit
  };
};